<template>
  <div class="modal fade" id="feedback" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-info">
            <h3 class="block-title"><i class="far fa-comment"></i> Give Feedback</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Subject</label>
              <input type="text" v-model="subject" name="subject" v-validate="'required'" data-vv-as="Subject" class="form-control form-control-alt" placeholder="Subject">
              <p v-if="errors.has('subject')" class="errorMsg">{{ errors.first('subject') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Description</label>
              <textarea v-model="description" name="description" v-validate="'required'" data-vv-as="Description" class="form-control form-control-alt" placeholder="Description"> {{ description }}</textarea>
              <p v-if="errors.has('description')" class="errorMsg">{{ errors.first('description') }}</p>
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="send()" :bind:disabled="showModalLoader">
              <div><span>Send</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import { mapActions } from 'vuex';

Vue.use(VeeValidate, VueSpinners);
export default {
  name: 'Feedback',
  data() {
    return {
      subject: '',
      description: '',
      showModalLoader: false,
      errorMsg: ''
    };
  },
  components: {
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    clearData() {
      this.subject = '';
      this.description = '';
      this.errorMsg = '';
      this.$validator.reset();
    },
    send() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/user/feedback', {
            subject: vm.subject,
            description: vm.description
          }).then((data) => {
            if (data.status === 'success') {
              vm.success(data.message);
              jQuery('#feedback').modal('hide');
              helper.triggerMessageModal('#alert_modal');
              vm.clearData();
            } else {
              vm.errorMsg = data.message;
            }
          });
          vm.showModalLoader = false;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/modals/Feedback.vue